import { combineReducers } from "redux";
import { routerReducer } from "react-router-redux";
import { reducer as formReducer } from "redux-form";
import auth from "./auth";
import resources from "./resources";
import paginator from "./paginator"
import search from "./search";
import filtersReducer from "reducers/filters";

export default combineReducers({
  filters: filtersReducer,
  auth,
  form: formReducer,
  resources,
  search,
  paginator,
  router: routerReducer
});



// WEBPACK FOOTER //
// ./src/reducers/index.js